/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const routineCreatePreviewResponseOutputDraftRoutineIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineCreatePreviewResponseOutputTimelineDaySlicesItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineCreatePreviewResponseOutputTimelineDaySlicesItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineCreatePreviewResponseOutputTimelineDaySlicesMax = 35;

export const routineCreatePreviewResponseOutputTimelineAgentsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineCreatePreviewResponseOutputTimelineAgentsItemDisplayNameMax = 500;

export const routineCreatePreviewResponseOutputTimelineAgentsItemInitialsMax = 8;

export const routineCreatePreviewResponseOutputTimelineAgentsMax = 1000;

export const routineCreatePreviewResponseOutputTimelineRangeStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineCreatePreviewResponseOutputTimelineRangeEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineCreatePreviewResponseOutputTimelineDisplayTimeZoneMax = 100;

export const routineCreatePreviewResponseOutputTimelineSchedulesItemScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineCreatePreviewResponseOutputTimelineSchedulesItemTimeZoneMax = 100;

export const routineCreatePreviewResponseOutputTimelineSchedulesItemVersionExclusiveMin = 0;
export const routineCreatePreviewResponseOutputTimelineSchedulesItemVersionMax = 9007199254740991;

export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemPendingHistoryOneStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemPendingHistoryOneEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemRotationCountExclusiveMin = 0;
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemRotationCountMax = 2147483647;

export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceRoutineVersionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourcePositionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemUserIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemStartOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemEndOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemHistoryRecordedThroughOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalMax = 10000;

export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemOverrideIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemSubstituteUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOverridesMax = 10000;

export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceRoutineVersionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourcePositionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemUserIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemStartOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemEndOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemHistoryRecordedThroughOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalMax = 10000;

export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemGapsItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemGapsItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemGapsMax = 10000;

export const routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesMax = 10;

export const routineCreatePreviewResponseOutputTimelineSchedulesMax = 300;

export const routineCreatePreviewResponseOutputTimelineViewVersionMax = 256;

export const RoutineCreatePreviewResponseOutput = zod.object({
  draftRoutineId: zod.uuid().regex(routineCreatePreviewResponseOutputDraftRoutineIdRegExp),
  timeline: zod.object({
    daySlices: zod
      .array(
        zod.object({
          start: zod.iso
            .datetime({ offset: true })
            .regex(routineCreatePreviewResponseOutputTimelineDaySlicesItemStartRegExp),
          end: zod.iso
            .datetime({ offset: true })
            .regex(routineCreatePreviewResponseOutputTimelineDaySlicesItemEndRegExp),
        }),
      )
      .max(routineCreatePreviewResponseOutputTimelineDaySlicesMax)
      .optional(),
    agents: zod
      .array(
        zod.object({
          id: zod.uuid().regex(routineCreatePreviewResponseOutputTimelineAgentsItemIdRegExp),
          displayName: zod
            .string()
            .min(1)
            .max(routineCreatePreviewResponseOutputTimelineAgentsItemDisplayNameMax),
          initials: zod
            .string()
            .min(1)
            .max(routineCreatePreviewResponseOutputTimelineAgentsItemInitialsMax),
        }),
      )
      .max(routineCreatePreviewResponseOutputTimelineAgentsMax)
      .optional(),
    range: zod.object({
      start: zod.iso
        .datetime({ offset: true })
        .regex(routineCreatePreviewResponseOutputTimelineRangeStartRegExp),
      end: zod.iso
        .datetime({ offset: true })
        .regex(routineCreatePreviewResponseOutputTimelineRangeEndRegExp),
    }),
    displayTimeZone: zod
      .string()
      .min(1)
      .max(routineCreatePreviewResponseOutputTimelineDisplayTimeZoneMax),
    schedules: zod
      .array(
        zod.object({
          scheduleId: zod
            .uuid()
            .regex(routineCreatePreviewResponseOutputTimelineSchedulesItemScheduleIdRegExp),
          name: zod.unknown().and(zod.unknown()),
          timeZone: zod
            .string()
            .min(1)
            .max(routineCreatePreviewResponseOutputTimelineSchedulesItemTimeZoneMax),
          version: zod
            .int()
            .gt(routineCreatePreviewResponseOutputTimelineSchedulesItemVersionExclusiveMin)
            .max(routineCreatePreviewResponseOutputTimelineSchedulesItemVersionMax),
          routines: zod
            .array(
              zod.object({
                pendingHistory: zod
                  .union([
                    zod.object({
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemPendingHistoryOneStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemPendingHistoryOneEndRegExp,
                        ),
                    }),
                    zod.null(),
                  ])
                  .optional(),
                routineId: zod
                  .uuid()
                  .regex(
                    routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemRoutineIdRegExp,
                  ),
                name: zod.unknown().and(zod.unknown()),
                rotation: zod.object({
                  unit: zod.enum(['day', 'week']),
                  count: zod
                    .int()
                    .gt(
                      routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemRotationCountExclusiveMin,
                    )
                    .max(
                      routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemRotationCountMax,
                    ),
                }),
                original: zod
                  .array(
                    zod.object({
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemEndRegExp,
                        ),
                      source: zod.object({
                        scheduleId: zod
                          .uuid()
                          .regex(
                            routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceScheduleIdRegExp,
                          ),
                        routineId: zod
                          .uuid()
                          .regex(
                            routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceRoutineIdRegExp,
                          ),
                        routineVersionId: zod
                          .uuid()
                          .regex(
                            routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceRoutineVersionIdRegExp,
                          ),
                        positionId: zod
                          .uuid()
                          .regex(
                            routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourcePositionIdRegExp,
                          ),
                        originalUserId: zod
                          .uuid()
                          .regex(
                            routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceOriginalUserIdRegExp,
                          ),
                        originalEligible: zod.boolean(),
                        overrideId: zod.union([
                          zod
                            .uuid()
                            .regex(
                              routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceOverrideIdOneRegExp,
                            ),
                          zod.null(),
                        ]),
                      }),
                      userId: zod.union([
                        zod
                          .uuid()
                          .regex(
                            routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemUserIdOneRegExp,
                          ),
                        zod.null(),
                      ]),
                      eligible: zod.boolean(),
                      startOffset: zod
                        .string()
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemStartOffsetRegExp,
                        ),
                      endOffset: zod
                        .string()
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemEndOffsetRegExp,
                        ),
                      history: zod.object({
                        recordedThrough: zod.union([
                          zod.iso
                            .datetime({ offset: true })
                            .regex(
                              routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemHistoryRecordedThroughOneRegExp,
                            ),
                          zod.null(),
                        ]),
                        finalized: zod.boolean(),
                      }),
                    }),
                  )
                  .max(
                    routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOriginalMax,
                  ),
                overrides: zod
                  .array(
                    zod.object({
                      overrideId: zod
                        .uuid()
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemOverrideIdRegExp,
                        ),
                      substituteUserId: zod
                        .uuid()
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemSubstituteUserIdRegExp,
                        ),
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemEndRegExp,
                        ),
                      effective: zod.boolean(),
                      eligible: zod.boolean(),
                    }),
                  )
                  .max(
                    routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemOverridesMax,
                  ),
                final: zod
                  .array(
                    zod.object({
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemEndRegExp,
                        ),
                      source: zod.object({
                        scheduleId: zod
                          .uuid()
                          .regex(
                            routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceScheduleIdRegExp,
                          ),
                        routineId: zod
                          .uuid()
                          .regex(
                            routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceRoutineIdRegExp,
                          ),
                        routineVersionId: zod
                          .uuid()
                          .regex(
                            routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceRoutineVersionIdRegExp,
                          ),
                        positionId: zod
                          .uuid()
                          .regex(
                            routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourcePositionIdRegExp,
                          ),
                        originalUserId: zod
                          .uuid()
                          .regex(
                            routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceOriginalUserIdRegExp,
                          ),
                        originalEligible: zod.boolean(),
                        overrideId: zod.union([
                          zod
                            .uuid()
                            .regex(
                              routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceOverrideIdOneRegExp,
                            ),
                          zod.null(),
                        ]),
                      }),
                      userId: zod.union([
                        zod
                          .uuid()
                          .regex(
                            routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemUserIdOneRegExp,
                          ),
                        zod.null(),
                      ]),
                      eligible: zod.boolean(),
                      startOffset: zod
                        .string()
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemStartOffsetRegExp,
                        ),
                      endOffset: zod
                        .string()
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemEndOffsetRegExp,
                        ),
                      history: zod.object({
                        recordedThrough: zod.union([
                          zod.iso
                            .datetime({ offset: true })
                            .regex(
                              routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalItemHistoryRecordedThroughOneRegExp,
                            ),
                          zod.null(),
                        ]),
                        finalized: zod.boolean(),
                      }),
                    }),
                  )
                  .max(routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemFinalMax),
                gaps: zod
                  .array(
                    zod.object({
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemGapsItemStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemGapsItemEndRegExp,
                        ),
                      reason: zod.enum([
                        'outside-sections',
                        'before-start',
                        'ineligible',
                        'ended',
                        'archived',
                        'empty-dst-section',
                      ]),
                    }),
                  )
                  .max(routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesItemGapsMax),
              }),
            )
            .max(routineCreatePreviewResponseOutputTimelineSchedulesItemRoutinesMax),
        }),
      )
      .max(routineCreatePreviewResponseOutputTimelineSchedulesMax),
    viewVersion: zod.string().min(1).max(routineCreatePreviewResponseOutputTimelineViewVersionMax),
  }),
});

export type RoutineCreatePreviewResponseOutput = zod.input<
  typeof RoutineCreatePreviewResponseOutput
>;
export type RoutineCreatePreviewResponseOutputOutput = zod.output<
  typeof RoutineCreatePreviewResponseOutput
>;
